/**
 * "From Precepi" announcements on Home. Static config: edit here, then deploy the frontend.
 * No placeholder copy ships; leave an item out until its copy is real.
 */
export interface FromPrecepiItem {
  id: string;
  kind: 'coming-soon' | 'training' | 'new';
  eyebrow: string;
  title: string;
  body?: string;
  action?: { label: string; href: string };
  adminOnly?: boolean;
}

/** No updates page exists yet: null hides the "All updates" link. */
export const FROM_PRECEPI_ALL_UPDATES_URL: string | null = null;

export const FROM_PRECEPI_ITEMS: FromPrecepiItem[] = [
  {
    id: 'agentic-reporting-beta',
    kind: 'new',
    eyebrow: 'NEW · BETA',
    title: 'Agentic reporting is open for testing',
    body: "Turn a question into a cited report you can edit, export and share. Try it on your next question and tell us what's missing.",
    action: { label: 'Try agentic reporting', href: '/?mode=workstream' },
    adminOnly: true,
  },
  {
    id: 'training-ab-view',
    kind: 'training',
    eyebrow: 'TRAINING · VIDEO',
    title: 'Compare view and starring results',
    body: 'Star the results that matter, then read labels side by side, section by section, in Compare.',
    action: { label: 'Watch video', href: '/training?video=compare-view-starring' },
  },
];
